import { MoreHoriz } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMoreHoriz12Line = createIcon(MoreHoriz, 12, "Line");
export const IconMoreHoriz16Line = createIcon(MoreHoriz, 16, "Line");
export const IconMoreHoriz20Line = createIcon(MoreHoriz, 20, "Line");
export const IconMoreHoriz24Line = createIcon(MoreHoriz, 24, "Line");
export const IconMoreHoriz32Line = createIcon(MoreHoriz, 32, "Line");
export const IconMoreHoriz48Line = createIcon(MoreHoriz, 48, "Line");
export const IconMoreHoriz64Line = createIcon(MoreHoriz, 64, "Line");
